export var iconColorMapping = {
  default: 'neutral.black',
  inverted: 'neutral.white',
  inherit: 'inherit',
  brand: 'brand.main'
};
/**
 * @private For internal use only.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
//# sourceMappingURL=_BaseIcon.types.js.map